import React, { PureComponent } from 'react';
import { Table, Icon, Button, Tooltip } from 'antd';
import a from '@/assets/Message.wav';
import './messageRemind.scss';
import moment from 'moment'




class MessageRemind extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      columns: [
        {
          title: '创建时间',
          dataIndex: 'CreateDtTm',
          key: 'CreateDtTm',
          align: 'center',
          width: 170,
          render: text => <span>{moment(text).format('YYYY-MM-DD HH:mm')}</span>,
        },
        {
          title: '信息',
          dataIndex: 'MSG_DETAILED',
          key: 'MSG_DETAILED',
          render: text => (
            <Tooltip placement="topLeft" title={text}>
              {text}
            </Tooltip>
          ),
        },
        {
          title: '',
          dataIndex: '',
          key: 'MSG_UID',
          align: 'center',
          width: 120,
          render: text => <Button onClick={() => this.props.markAsReadFn(text)}>标记为已读</Button>,
        }
      ]
    }
  }
  handleReadMsg = () => {
    const { messageAlertList } = this.props;
    this.props.markAsReadFn(messageAlertList)
  }
  render() {
    const { messageAlertList, rowSelection, handleCloseMsg, isShowMessageAlert } = this.props;

    return (
      // <div id="notifiTable" style={{display: messageAlertList && (messageAlertList.size > 0) ? 'block' : 'none'}}>
      <div id={this.props.className}>
        <audio autoPlay ref={(alertAudio) => { this.alertAudio = alertAudio }} loop src={isShowMessageAlert ? a : ''}>
        </audio>
        {/* {this.props.show} */}

        <div className="msgAlert">
          <p>{this.props.title}</p>
          <p className="closeMsg" onClick={() => handleCloseMsg(this.alertAudio)}><Icon type="close" /></p>
        </div>
        <Button onClick={this.handleReadMsg} style={{ margin: '10px' }}>全部已读</Button>
        <Table
          scroll={{ y: 280, scrollToFirstRowOnChange: true }}
          columns={this.state.columns}
          rowSelection={rowSelection}
          dataSource={messageAlertList}
          rowKey={record => record.MSG_UID}
          pagination={false}
          style={{ marginBottom: '20px' }}
          className="messageTable"
        // pagination={ {
        //   showTotal: ( count ) => {
        //     let pageNum = Math.ceil( count / 10 );
        //     return '共' + pageNum + '页 / ' + count + '条数据';
        //   }
        // } } 
        />
      </div>
    )
  }
}
export default MessageRemind;